import styled from "@emotion/styled";
import { Grid2 } from "@mui/material";

export const HeaderStyled = styled.header`
  padding: 10px 0;
  line-height: initial;
  height: ${props => (props.isOpen ? "100vh" : "auto")};
  overflow: ${props => (props.isOpen ? "scroll" : "visible")};

  @media (min-width: ${props => props.theme.screenSizes.mdMax}) {
    padding: ${p => p.theme.space[6]}px 0;
    height: auto;
    overflow: visible;
  }
`;

export const GridContainer = styled(Grid2)`
  align-items: center;
  position: relative;
  width: 100%;
`;

export const GridItem = styled(Grid2)`
  flex-grow: 1;
`;

export const GridItemOne = styled(Grid2)`
  margin-left: auto;

  order: 1;
  @media (min-width: ${props => props.theme.screenSizes.mdMax}) {
    order: 0;
  }
`;
export const GridItemTwo = styled(Grid2)`
  margin-left: auto;

  @media (min-width: ${props => props.theme.screenSizes.mdMax}) {
    margin-left: 0;
  }
`;
